import { Building2 } from "lucide-react";

import { useClienteCreateForm } from "@/hooks/clientes/use-cliente-form";
import { ClienteFormDialog } from "./ClienteFormDialog";

interface ClienteCreateFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ClienteCreateFormDialog({ open, onOpenChange }: ClienteCreateFormDialogProps) {
  const { form, isSubmitting, onSubmit } = useClienteCreateForm(open, onOpenChange);

  return (
    <ClienteFormDialog
      open={open}
      onOpenChange={onOpenChange}
      form={form}
      isSubmitting={isSubmitting}
      onSubmit={onSubmit}
      icon={<Building2 className="h-5 w-5" />}
      title="Novo cliente"
      subtitle="Preencha os dados para cadastrar o cliente."
      submitLabel="Criar cliente"
      submittingLabel="Criando..."
      isCreate
    />
  );
}
